// extracted by css-extract-rspack-plugin
export default {"button":"PullRequestButton-module__button__CC2AK","disabled":"PullRequestButton-module__disabled__h1bkp","diffIcon":"PullRequestButton-module__diffIcon__W5C1U"};